function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M17.066 21H6.934A1.934 1.934 0 015 19.066V4.935c0-1.068.866-1.934 1.934-1.934h10.131c1.069 0 1.935.866 1.935 1.934v14.13A1.934 1.934 0 0117.066 21v0z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19 8H5M8.002 14.949a.05.05 0 01.05.05.05.05 0 01-.05.05.05.05 0 01-.05-.05.05.05 0 01.05-.05M12.001 14.951a.05.05 0 01.05.05.05.05 0 01-.05.05.05.05 0 01-.05-.05.049.049 0 01.05-.05M16.002 14.949a.05.05 0 01.05.05.05.05 0 01-.05.05.05.05 0 01-.05-.05.05.05 0 01.05-.05M8.002 11.949a.05.05 0 01.05.05.05.05 0 01-.05.05.05.05 0 01-.05-.05.05.05 0 01.05-.05M12.001 11.951a.05.05 0 01.05.05.05.05 0 01-.05.05.05.05 0 01-.05-.05.049.049 0 01.05-.05M16.002 11.949a.05.05 0 01.05.05.05.05 0 01-.05.05.05.05 0 01-.05-.05.05.05 0 01.05-.05M8.002 17.949a.05.05 0 01.05.05.05.05 0 01-.05.05.05.05 0 01-.05-.05.05.05 0 01.05-.05M12.001 17.951a.05.05 0 01.05.05.05.05 0 01-.05.05.05.05 0 01-.05-.05.049.049 0 01.05-.05M16.002 17.949a.05.05 0 01.05.05.05.05 0 01-.05.05.05.05 0 01-.05-.05.05.05 0 01.05-.05",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgCalculator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgCalculator;